import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface WorkerState {
  workerName: string
  setWorkerName: (name: string) => void
}

export const useWorkerStore = create<WorkerState>()(
  persist(
    (set) => ({
      workerName: '',
      setWorkerName: (name: string) => set({ workerName: name }),
    }),
    { name: 'truemark-worker' },
  ),
)
